import { GetWalkmeDataFunc, WalkmeName } from 'src/types/walkme.model';
import GetTransactionClassificationData from './TransactionClassificationWalkmeData';

const dataMap: { [key: string]: GetWalkmeDataFunc } = {
    [WalkmeName.TRANSACTION_CLASSIFICATION]: GetTransactionClassificationData
    // Add more walkme data here
};

export default dataMap;
